export interface RenewalsModuleState {
  originalQuoteRequestId: number | null;
  originalQuoteDueDate: Date | null;
}

export const renewalsModuleInitialState: RenewalsModuleState = {
  originalQuoteRequestId: null,
  originalQuoteDueDate: null,
};
